var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader"},[_c('img',{staticClass:"preloader__image",attrs:{"src":require("../../img/preloader.svg"),"alt":"preloader"}})])}
var staticRenderFns = []

export { render, staticRenderFns }